module.exports = __webpack_public_path__ + "static/about-a35ee89888bbb638608dd74a9db10000.jpg";